import { Injectable } from "@nestjs/common";
import { ProcurementTypesDto } from "libs/shared-models/procurement-management/src/lib/procurement-types/procurement-types-dto";
import { ProcurementType } from "../procurement-types.entity";


@Injectable()
export class ProcurementTypeAdapter {

    public convertEntityToDto(procurementTypeObject: ProcurementType): ProcurementTypesDto {
        const procurementTypeDto = new ProcurementTypesDto();
       
        procurementTypeDto.status = procurementTypeObject.status;
        procurementTypeDto.versionFlag = procurementTypeObject.versionFlag;
        procurementTypeDto.createdAt = procurementTypeObject.createdAt;
        procurementTypeDto.createdUser = procurementTypeObject.createdUser;
        procurementTypeDto.updatedAt = procurementTypeObject.updatedAt;
        procurementTypeDto.updatedUser = procurementTypeObject.updatedUser;
        procurementTypeDto.procurementType = procurementTypeObject.procurementType;
        return procurementTypeDto;
    }
}
